export const BASE_ACTION_TYPES = {
    SET_HEADER_FORM_NAME: 'SET_HEADER_FORM_NAME',
    SET_FOOTER_BACK_ACTION: 'SET_FOOTER_BACK_ACTION',
    SET_FOOTER_NEXT_ACTION: 'SET_FOOTER_NEXT_ACTION',
    SET_FOOTER_CANCEL_ACTION: 'SET_FOOTER_CANCEL_ACTION',
    SET_FOOTER_IS_WITH_ACTIONS: 'SET_FOOTER_IS_WITH_ACTIONS',
    SET_FOOTER_NEXT_BUTTON_TEXT: 'SET_FOOTER_NEXT_BUTTON_TEXT',
    SET_IS_FOOTER_ACCIDENT_COPYRIGHT: 'SET_IS_FOOTER_ACCIDENT_COPYRIGHT'
};